import React from 'react';
import { BaasicDropdown, BaasicInput, Loader, SliderCheckBox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { boldText } from 'core/utils';
import { observer } from 'mobx-react';
import templateFedEx from './Template-FedEx.svg';
import templateUPS from './Template-UPS.svg';
import templateUSPS from './Template-USPS.svg';

// Only these three carriers ship a label template.
const carrierTemplates = {
	FedEx: templateFedEx,
	UPS: templateUPS,
	USPS: templateUSPS,
};

const CustomLabelTemplate = ({
	t,
	viewStore: {
		loading,
		form,
		onCustomFieldInputChange,
		resetValues,
		stateDropdownStore,
		carrierTypeDropdownStore,
		onUseCustomReturnAddressChange,
		modalParams,
		setInputs,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<form className="ReactModal__form" onSubmit={form.onSubmit}>
				<div className="ReactModal__header">
					<h3 className="spc--bottom--sml">{t('CUSTOMLABEL.TITLE')}</h3>
				</div>
				<div className="ReactModal__body">
					<div className="row">
						<div className="col col-sml-12 col-lrg-5">
							<div className="w--250--px spc--bottom--sml">
								<BaasicDropdown dropdownStore={carrierTypeDropdownStore} />
							</div>
							{carrierTypeDropdownStore.value && (
								<object
									className="w--100"
									type="image/svg+xml"
									data={carrierTemplates[carrierTypeDropdownStore.value.label]}
									id="svgDocumentId"
								></object>
							)}
						</div>
						<div className="col col-sml-12 col-lrg-7">
							<div className="box__header">
								<SliderCheckBox
									field={form.$('useCustomReturnAddress')}
									customMessage={t('CUSTOMLABEL.CUSTOMRETURNADDRESS')}
									onChangeCallback={() => onUseCustomReturnAddressChange(form.$('useCustomReturnAddress'))}
								/>
							</div>
							<div className="row spc--bottom--sml">
								<div className="col col-sml-12 col-med-6">
									<BaasicInput className="spc--bottom--sml" field={form.$('attentionName')} reference={setInputs} />
								</div>

								{form.$('useCustomReturnAddress').value ? (
									<React.Fragment>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('returnName')} reference={setInputs} />
										</div>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('returnPhone')} reference={setInputs} />
										</div>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('returnAddress')} reference={setInputs} />
										</div>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('returnCity')} reference={setInputs} />
										</div>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('returnZip')} reference={setInputs} />
										</div>
										<div className="col col-sml-12 col-lrg-6">
											<BaasicDropdown dropdownStore={stateDropdownStore} />
										</div>
									</React.Fragment>
								) : (
									<React.Fragment>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('sellerName')} reference={setInputs} />
										</div>
										<div className="col col-sml-12 col-med-6">
											<BaasicInput className="spc--bottom--sml" field={form.$('sellerPhone')} reference={setInputs} />
										</div>
									</React.Fragment>
								)}
							</div>
							<div className="spc--bottom--sml">
								<div className="box__header">
									<h4>{t('CUSTOMLABEL.CUSTOMFIELDS')}</h4>
								</div>
								{boldText(t(['CUSTOMLABEL.CUSTOMFIELDSMESSAGE']))}
							</div>

							{form.$('customFieldInputs').map((customFieldInput, index) => {
								return <CustomField key={index} {...{ index, t, customFieldInput, onCustomFieldInputChange }} />;
							})}
						</div>
					</div>
				</div>

				<div className="ReactModal__footer">
					<div className="flex--secondary">
						<div>
							<button className="btn btn--med btn--primary spc--right--tny spc--bottom--sml" type="submit">
								{t('SAVE')}
							</button>
							<button className="btn btn--med btn--outline spc--bottom--sml" onClick={() => modalParams.close()}>
								{t('CANCEL')}
							</button>
						</div>
						<button className="btn btn--med btn--outline spc--bottom--sml" type="button" onClick={() => resetValues()}>
							{t('RESET')}
						</button>
					</div>
				</div>
			</form>
		</section>
	);
};

const CustomField = observer(({ t, customFieldInput, index, onCustomFieldInputChange }) => {
	return (
		<React.Fragment key={index}>
			<div className="pos--rel">
				<div className="spc--bottom--sml">
					<BaasicInput
						value={customFieldInput.$('value').value}
						className="spc--bottom--sml"
						field={customFieldInput.$('value')}
						placeholder={t('CUSTOMLABEL.CUSTOMTEXT')}
						customMessage={t('CUSTOMLABEL.SELECTVARIABLE')}
						onKeyUp={event => onCustomFieldInputChange(event, customFieldInput)}
						autoComplete="off"
						labelAddon={customFieldInput.labelAddon}
						reference={customFieldInput.setRef}
					/>
				</div>
				<div hidden={customFieldInput.$('displayDropdown').value ? '' : 'hidden'} className="dropdown--custom-field">
					{customFieldInput.customFieldVariableDropdown && customFieldInput.$('displayDropdown').value && (
						<BaasicDropdown
							menuIsOpen
							dropdownStore={customFieldInput.customFieldVariableDropdown}
							autoFocus
							isSearchable
							isClearable={false}
						/>
					)}
				</div>
			</div>
		</React.Fragment>
	);
});

export default defaultTemplate(CustomLabelTemplate);
